"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodsMap = void 0;
/* eslint-disable import/prefer-default-export */
const types_1 = require("./types");
const visa_master_png_1 = __importDefault(require("../../../../static/payments/visa_master.png"));
const sepa_svg_1 = __importDefault(require("../../../../static/payments/sepa.svg"));
const applepay_svg_1 = __importDefault(require("../../../../static/payments/applepay.svg"));
const ach_svg_1 = __importDefault(require("../../../../static/payments/ach.svg"));
const googlepay_svg_1 = __importDefault(require("../../../../static/payments/googlepay.svg"));
exports.paymentMethodsMap = {
    [types_1.PaymentMethodName.MANUAL_BANK_TRANSFER]: {
        id: "manual",
        icon: sepa_svg_1.default,
    },
    [types_1.PaymentMethodName.APPLE_PAY]: {
        id: "apple_pay",
        icon: applepay_svg_1.default,
    },
    [types_1.PaymentMethodName.GOOGLE_PAY]: {
        id: "google_pay",
        icon: googlepay_svg_1.default,
    },
    [types_1.PaymentMethodName.CARD_PAYMENT]: {
        id: "card",
        icon: visa_master_png_1.default,
    },
    [types_1.PaymentMethodName.AUTO_BANK_TRANSFER]: {
        id: "auto",
        icon: ach_svg_1.default,
    },
};
//# sourceMappingURL=paymentMethods.js.map